import React, { useState } from "react";
import { useAppDispatch } from "../app/store";
import { forgotPassword } from "../features/authSlice";
import { Col, Container, Image, Row } from "react-bootstrap";
import { BarLoader } from "react-spinners";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const handleSubmit = (e: React.FormEvent) => {
    setLoading(true);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setLoading(false);
      alert("Please enter a valid email address.");
      return;
    }
    e.preventDefault();
    // Dispatch the forgotPassword action with the email
    dispatch(forgotPassword(email))
      .unwrap()
      .then((response: string) => {
        setLoading(false);
        setEmail("");
        toast.success("Password reset link sent to your email."); // Show success message
      })
      .catch((error: any) => {
        setEmail("");
        setLoading(false);
        toast.error(error.message); // Show error message
      });
  };

  return (
    <div>
      <Container>
        <Row>
          <Col sm={12} md={12}>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ marginTop: "10%" }}
            >
              <div className="card w-50 shadow-lg p-3 mb-5 bg-body-tertiary rounded border-0">
                <div className="card-body py-5">
                  <div className="d-flex justify-content-center mb-3">
                    <Image
                      src="/images/logo.png"
                      className="img-fluid"
                      alt="images"
                    />
                  </div>
                  <h3 className="text-center fw-bold">Forgot Password </h3>

                  <div className="form-group mb-4">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control p-3 rounded-0"
                      name="email"
                      placeholder="Email Address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="form-group mt-3">
                    {loading && loading ? (
                      <BarLoader
                        color="#073367"
                        loading={loading}
                        width={150}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    ) : (
                      <button
                        className="btn btn-primary w-100 p-3"
                        onClick={handleSubmit}
                      >
                        <h4>Login</h4>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;
